import actions from './actions'
import mutations from './mutations'

const moderation = {
    namespaced: true,
    state: {
        requests: [],
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        isLoaded: true,
        filters: {
            type: null,
            status: 'check',
            email: null
        },
        resetAccountFeeDate: null
    },
    mutations,
    actions
}

export default moderation
